<template lang="pug">
small
  div #[small Referências de resposta:]
  div
    cite #[small {{ pergunta.referencia_resposta.info }}]
  .columns
    .column(v-if="!['checkbox', 'radio'].includes(pergunta.tipo)")
      .columns.mb-2.align-center.bg-gray.p-1.s-rounded(v-for="condicao in pergunta.referencia_resposta.condicoes" :key="condicao.operacao")
        .column(:class="valido(condicao, pergunta.resposta) ? 'text-success' : 'text-error'")
          i(:class="valido(condicao, pergunta.resposta) ? 'fa fa-check' : 'fa fa-times'")
          |  {{ referenciaMapping(condicao.operacao).titulo }}: #[b {{ labelEsperado(condicao) }}]
    .column(v-else)
      .mb-2.align-center.bg-gray.p-1.s-rounded(
        v-for="condicao in pergunta.referencia_resposta.condicoes"
        :key="condicao.operacao"
        :class="validarAlternativas(condicao, pergunta.resposta) ? 'text-success' : 'text-error'"
      )
        .columns
          .column 
            i(:class="validarAlternativas(condicao, pergunta.resposta) ? 'fa fa-check' : 'fa fa-times'")
            |  {{ referenciaMapping(condicao.operacao).titulo }}
        .ml-2.pl-2(v-for="alternativaId in condicao.esperado")
          i.fa.fa-check-square
          |  {{ getTitulo(alternativaId) }}
</template>

<script>
import referencias from "@/lib/checklistReferencia"

export default {
  props: { pergunta: Object },
  methods: {
    referenciaMapping(operacao) {
      return referencias.find(referencia => referencia.operacao === operacao)
    },
    labelEsperado(condicao) {
      if (this.pergunta.tipo === "sim_nao")
        return condicao.esperado ? "Sim" : "Não"
      if (["in", "not_in"].includes(condicao.operacao))
        return condicao.esperado.join(" - ")

      if (["between", "not_between"].includes(condicao.operacao))
        return `${condicao.esperado[0]} à ${condicao.esperado[1]}`

      return condicao.esperado
    },
    getTitulo(alternativaId) {
      const alternativa = this.pergunta.alternativas[alternativaId]
      if (!alternativa) return ""
      return alternativa.titulo
    },
    valido(condicao, resposta) {
      const { validacao } = this.referenciaMapping(condicao.operacao) || {
        validacao: () => true,
      }
      return validacao(condicao.esperado, resposta)
    },
    validarAlternativas(condicao, resposta) {
      const { validacao } = this.referenciaMapping(condicao.operacao) || {
        validacao: () => true,
      }
      for (const alternativaId of resposta.length ? resposta : [resposta]) {
        const valido = validacao(condicao.esperado, alternativaId)
        if (!valido) return false
      }
      return true
    },
  },
}
</script>
